import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomeContentService {
  apiPrefix: string;
  headers = new HttpHeaders();

  constructor(private http: HttpClient) {
    this.apiPrefix = environment.baseUrl + 'api/v1/content/';
    this.headers = this.headers.set(
      'x-access-token',
      localStorage.getItem('adventouresAdminAuthToken')
    );
  }

  createContent(params) {
    return this.http.post(this.apiPrefix + 'create', params, {
      headers: this.headers,
    });
  }

  updateContent(params) {
    return this.http.post(this.apiPrefix + 'update', params, {
      headers: this.headers,
    });
  }

  getContent(params) {
    return this.http.post(this.apiPrefix + 'get-admin', params, {
      headers: this.headers,
    });
  }
}
